export default __webpack_public_path__ + "static/usa_megamillions-894d94034535465b88122fea461ec99e.png";